/* eslint-disable import/no-extraneous-dependencies, arrow-body-style,object-curly-newline */
/* global React */
import RefHoc from 'platform/react/hoc/pubsub/ref'
import Section from 'ui/Element/Section'

const SubbedRefSection = RefHoc(React.forwardRef(Section))

export default SubbedRefSection
